function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import ImagePreview from "./ImagePreview";
import VideoPreview from "./VideoPreview";
import AudioPreview from "./AudioPreview";
import SourcePreview from "./SourcePreview";
const templates = {
  "image": ImagePreview,
  "video": VideoPreview,
  "audio": AudioPreview
};

const MediaPreview = (_ref) => {
  let mediaType = _ref.mediaType,
      source = _ref.source,
      media = _objectWithoutPropertiesLoose(_ref, ["mediaType", "source"]);

  if (!mediaType) {
    return React.createElement("p", null, "No mediaType");
  }

  const PreviewTemplate = mediaType && templates[mediaType] || source && SourcePreview;

  if (!PreviewTemplate) {
    return React.createElement("p", null, "No template for mediaType:", mediaType);
  }

  return React.createElement(PreviewTemplate, _extends({}, media, {
    source: source
  }));
};

export default MediaPreview;